// extracted by mini-css-extract-plugin
export default {"cardsContainer":"burger-constructor-list_cardsContainer__oZmRP"};